import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>ITEP <br /><span style={{fontSize:'16px'}}>(Intergrated Teachers Education Programme under process)</span></h1>
                <p>Home &gt; ITEP</p>
            </div>
        </div>
    )
}

export default Hero;